import { render } from "./dental_investigations.vue?vue&type=template&id=6790b4d4&scoped=true"
import script from "./dental_investigations.vue?vue&type=script&lang=js"
export * from "./dental_investigations.vue?vue&type=script&lang=js"

import "./dental_investigations.vue?vue&type=style&index=0&id=6790b4d4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6790b4d4"]])

export default __exports__